import axios from '../index'
/**
 * @description 判断用户是否登录 获取用户的身份
 * @author txw
 * @date 2019-06-04
 * @export
 */
export function isLogin () {
  return axios.post(`/visitor/is-login`)
}
